// config.js
// In production (Docker), REACT_APP_API_URL is set to '' (empty string) so all API
// calls use same-origin relative paths — nginx in the FE container proxies them to
// the Go API container. In local dev, falls back to localhost:8080.
const config = {
  BASE_URL: process.env.REACT_APP_API_URL !== undefined
    ? process.env.REACT_APP_API_URL
    : 'http://localhost:8080',
};

export default config;